import { API_BASE_URL } from "./apiConfig";

export const apiFetch = async (url, options = {}) => {
  const token = localStorage.getItem("authToken");

  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  const response = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    // Token expired or invalid
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    const pathParts = window.location.pathname.split("/");
    const tenantHash = pathParts[1]; // be296dc2-8c58-4263-8409-d3f883902efe

    window.location.href = `/${tenantHash}/login`;
    return;
  }

  return response.json();
};
